import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import { useMemo } from 'react';

function DashboardFilterMultiple({
  options,
  value,
  onChange,
  emptyLabel,
  optionLabel,
  showFilter
}) {
  const isActive = useMemo(() => value && value.length, [value]);
  return (
    <MultiSelect
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      optionLabel={optionLabel || 'label'}
      placeholder={emptyLabel}
      scrollHeight={'350px'}
      className={classNames(`!text-sm !rounded-full !pl-1`, {
        'active-custom-dropdown': isActive
      })}
      showSelectAll={false}
      showClear={true}
      filter={showFilter}
      maxSelectedLabels={2}
      selectedItemsLabel={`{0} séléctionnés`}
    />
  );
}

export default DashboardFilterMultiple;
